import React, { useEffect, useState } from 'react';

import {
  Button,
  QuantaFormik,
  QuantaForm,
  QuantaInput,
  Text,
  Label,
  QuantaCheckbox,
  Grid,
  GridItem,
  Chip,
  useResponsiveParams,
  useQuantaFormikContext,
} from 'quanta-ui';
import { faSpinner, faSms } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useMutation } from '@apollo/client';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import {
  SEND_QUOTE_SMS_FIRE,
  MOBILE_NUMBER_STARTING_WITH,
} from '../../queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {  Loading } from '../../../../../../lib/layout';
import { Error, Loading } from 'quanta-flows/modules/layout';

export default function SMSFragment({
  fireQuoteInput,
  goBack,
  initialMobile,
}) {
  const fetchQuery = useFetchQuery();
  const [sentSuccess, setSentSuccess] = useState(true);
  const [loading, setLoading] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [mobileNumberStartingWith, setMobileNumberStartingWith] =
    useState(null);
  const [
    loadingMobileNumberStartingWith,
    setLoadingMobileNumberStartingWith,
  ] = useState(false);
  const [
    errorMobileNumberStartingWith,
    setErrorMobileNumberStartingWith,
  ] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (isMounted && !mobileNumberStartingWith) {
      setLoadingMobileNumberStartingWith(true);
      setErrorMobileNumberStartingWith(null);
      fetchQuery({
        query: MOBILE_NUMBER_STARTING_WITH,
        fetchPolicy: 'cache-first',
      })
        ?.then((response) => {
          if (isMounted) {
            setLoadingMobileNumberStartingWith(false);
            setMobileNumberStartingWith(
              response?.data?.mobileNumberStartingWith,
            );
          }
        })
        ?.catch((error) => {
          if (isMounted) {
            setLoadingMobileNumberStartingWith(false);
            setErrorMobileNumberStartingWith(error?.message);
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, [mobileNumberStartingWith]);

  const [doSendSMS] = useMutation(SEND_QUOTE_SMS_FIRE, {
    onCompleted: (data) => {
      setSentSuccess(true);
      setDisplayMessage(data[`${Object.keys(data)[0]}`]?.message);
      setLoading(false);
    },
    onError: (_) => {
      setSentSuccess(false);
      setDisplayMessage(
        'Message send failed...Please try again after some time.',
      );
      setLoading(false);
    },
  });

  const onSubmit = async (values, { setFieldValue }) => {
    try {
      setLoading(true);
      setDisplayMessage(null);
      let variables = null;
      if (
        values?.alternateMobile &&
        !validate(values)?.alternateMobile
      ) {
        setFieldValue(`alternateMobileNos`, [
          ...values?.alternateMobileNos,
          values?.alternateMobile,
        ]);
        setFieldValue(`alternateMobile`, '');
        variables = {
          ...fireQuoteInput,
          mobile: values?.mode?.sms ? values.mobile : '',
          alternateMobileNos: values?.mode?.sms
            ? [...values?.alternateMobileNos, values?.alternateMobile]
            : [],
          whatsappNo:
            values?.isWhatsAppSameAsMobile &&
            values?.mode?.sms &&
            values?.mode?.whatsapp
              ? values?.mobile
              : values?.mode?.whatsapp
              ? values?.whatsappNo
              : '',
          modes:
            values?.mode?.sms && values?.mode?.whatsapp
              ? ['sms', 'whatsapp']
              : !values?.mode?.sms && values?.mode?.whatsapp
              ? ['whatsapp']
              : ['sms'],
        };
      } else {
        variables = {
          ...fireQuoteInput,
          mobile: values?.mode?.sms ? values.mobile : '',
          alternateMobileNos: values?.mode?.sms
            ? [...values?.alternateMobileNos, values?.alternateMobile]
            : [],
          whatsappNo:
            values?.isWhatsAppSameAsMobile &&
            values?.mode?.sms &&
            values?.mode?.whatsapp
              ? values?.mobile
              : values?.mode?.whatsapp
              ? values?.whatsappNo
              : '',
          modes:
            values?.mode?.sms && values?.mode?.whatsapp
              ? ['sms', 'whatsapp']
              : !values?.mode?.sms && values?.mode?.whatsapp
              ? ['whatsapp']
              : ['sms'],
        };
      }
      if (SEND_QUOTE_SMS_FIRE) {
        doSendSMS({
          variables,
        });
      }
    } catch (error) {
      setSentSuccess(false);
      setDisplayMessage(
        'Message send failed...Please try again after some time.',
      );
      setLoading(false);
    }
  };

  const messageSize = useResponsiveParams({
    for_iPad: 'large',
    for_mobile: 'normal',
  });

  const initialValues = {
    mobile: initialMobile ? initialMobile : '',
    alternateMobile: '',
    alternateMobileNos: [],
    whatsappNo: initialMobile ? initialMobile : '',
    isWhatsAppSameAsMobile: true,
    mode: {
      sms: true,
      whatsapp: false,
    },
  };

  const validate = (values) => {
    const errors = {};
    if (!values?.mobile) {
      errors.mobile = '* Required';
    } else if (
      parseInt(values?.mobile[0]) <
      parseInt(mobileNumberStartingWith?.value)
    ) {
      errors.mobile = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} to 9`;
    } else if (
      values?.mobile?.toString()?.length !== 10 ||
      !values?.mobile?.toString()?.match(/^[0-9]+$/)
    ) {
      errors.mobile = '* Mobile number must be of 10 digits';
    }
    if (
      values?.alternateMobile &&
      parseInt(values?.alternateMobile[0]) <
        parseInt(mobileNumberStartingWith?.value)
    ) {
      errors.alternateMobile = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} to 9`;
    } else if (
      values?.alternateMobile &&
      (values?.alternateMobile?.toString()?.length !== 10 ||
        !values?.alternateMobile?.toString()?.match(/^[0-9]+$/))
    ) {
      errors.alternateMobile = '* Mobile number must be of 10 digits';
    } else if (
      values?.alternateMobile &&
      (values?.alternateMobile?.trim()?.toLowerCase() ===
        values?.mobile?.trim()?.toLowerCase() ||
        values?.alternateMobileNos?.find(
          (alternateMob) =>
            alternateMob?.trim()?.toLowerCase() ===
            values?.alternateMobile?.trim()?.toLowerCase(),
        ))
    ) {
      errors.alternateMobile = '* This mobile no is already added';
    }
    if (values?.mode?.whatsapp) {
      if (!values?.whatsappNo) {
        errors.whatsappNo = '* Required';
      } else if (
        !values?.isWhatsAppSameAsMobile &&
        values?.mode?.sms &&
        values?.mode?.whatsapp &&
        values?.mobile?.toString() === values?.whatsappNo?.toString()
      ) {
        errors.whatsappNo =
          '* WhatsApp No cannot be same as mobile no';
      } else if (
        parseInt(values?.whatsappNo[0]) <
        parseInt(mobileNumberStartingWith?.value)
      ) {
        errors.whatsappNo = `* WhatsApp No must start with digit ${mobileNumberStartingWith?.value} to 9`;
      } else if (
        values.whatsappNo.toString().length !== 10 ||
        !values.whatsappNo.toString().match(/^[0-9]+$/)
      ) {
        errors.whatsappNo = '* WhatsApp No must be of 10 digits';
      }
    }
    return errors;
  };

  const SendSMSForm = ({}) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    return (
      <QuantaForm>
        <Label
          text={
            <Text type={'label'}>
              Select the mode <Text severity={'error'}>*</Text>
            </Text>
          }
          className="-mb-4"
        >
          <Grid repeat={3} gap={0}>
            <GridItem colSpan={1}>
              <QuantaCheckbox
                {...{
                  name: 'mode.sms',
                  label: `SMS`,
                  disabled: loading,
                }}
              />
            </GridItem>
            {/* <GridItem colSpan={1}>
              <QuantaCheckbox
                {...{
                  name: 'mode.whatsapp',
                  label: `WhatsApp`,
                  disabled: loading,
                }}
              />
            </GridItem> */}
          </Grid>
        </Label>
        {values?.mode?.whatsapp && !values?.mode?.sms ? (
          <>
            <QuantaInput
              name="whatsappNo"
              size="full"
              type="number"
              step="1"
              min={1000000000}
              max={9999999999}
              onDataChange={(val, _) => {
                setDisplayMessage(null);
              }}
              onKeyDown={(evt) =>
                evt.key === 'e' && evt.preventDefault()
              }
              label={
                <Text type={'label'}>
                  {' '}
                  WhatsApp No <Text severity="error">*</Text>
                </Text>
              }
              placeholder="Please enter your WhatsApp Number"
              disabled={loading}
            />
          </>
        ) : !values?.mode?.whatsapp && values?.mode?.sms ? (
          <>
            <QuantaInput
              name="mobile"
              size="full"
              type="number"
              step="1"
              min={1000000000}
              max={9999999999}
              onDataChange={(val, _) => {
                setDisplayMessage(null);
              }}
              onKeyDown={(evt) =>
                evt.key === 'e' && evt.preventDefault()
              }
              label={
                <Text type={'label'}>
                  {' '}
                  Mobile No <Text severity="error">*</Text>
                </Text>
              }
              placeholder="Please enter your mobile Number"
              disabled={loading}
            />
            <QuantaInput
              name="alternateMobile"
              type={'text'}
              label={
                <Text type={'label'}>Alternative Mobile Nos</Text>
              }
              size={'full'}
              placeholder={'Enter alternative numbers for SMS'}
              disabled={loading}
              onDataChange={(val, _) => {
                setDisplayMessage(null);
              }}
              onKeyDown={(evt) => {
                if (
                  ['tab', 'enter', ',', ';']?.includes(
                    evt?.key?.toString()?.trim()?.toLowerCase(),
                  )
                ) {
                  evt.preventDefault();
                  if (
                    values?.alternateMobile &&
                    !validate(values)?.alternateMobile
                  ) {
                    setFieldValue(`alternateMobileNos`, [
                      ...values?.alternateMobileNos,
                      values?.alternateMobile?.trim(),
                    ]);
                    setFieldValue(`alternateMobile`, '');
                  }
                }
              }}
              onPaste={(evt) => {
                evt.preventDefault();
                const paste = evt?.clipboardData
                  .getData('text')
                  ?.toString()
                  ?.trim();
                const phones = paste?.match(/[0-9]{10}/g);
                if (phones) {
                  const toBeAdded = phones?.filter(
                    (phone) =>
                      !values?.alternateMobileNos?.includes(phone) &&
                      phone !== values?.mobile,
                  );
                  setFieldValue(`alternateMobileNos`, [
                    ...values?.alternateMobileNos,
                    ...toBeAdded,
                  ]);
                }
              }}
            />
            {values?.alternateMobileNos?.length > 0 && (
              <Text className="flex gap-3 flex-wrap">
                {values?.alternateMobileNos?.map(
                  (alternateMobile, idx) => {
                    return (
                      <Chip
                        key={idx}
                        onRemove={(_) =>
                          setFieldValue(`alternateMobileNos`, [
                            ...values?.alternateMobileNos?.slice(
                              0,
                              idx,
                            ),
                            ...values?.alternateMobileNos?.slice(
                              idx + 1,
                            ),
                          ])
                        }
                        isChipDisabled={loading}
                      >
                        {alternateMobile}
                      </Chip>
                    );
                  },
                )}
              </Text>
            )}
          </>
        ) : values?.mode?.whatsapp && values?.mode?.sms ? (
          <>
            <QuantaInput
              name="mobile"
              size="full"
              type="number"
              step="1"
              min={1000000000}
              max={9999999999}
              onKeyDown={(evt) =>
                evt.key === 'e' && evt.preventDefault()
              }
              onDataChange={(val, _) => {
                setDisplayMessage(null);
                if (values?.isWhatsAppSameAsMobile) {
                  setFieldValue('whatsappNo', val);
                }
              }}
              label={
                <Text type={'label'}>
                  {' '}
                  Mobile No <Text severity="error">*</Text>
                </Text>
              }
              placeholder="Please enter your mobile Number"
              disabled={loading}
            />
            <QuantaCheckbox
              {...{
                name: 'isWhatsAppSameAsMobile',
                label: `WhatsApp no. same as mobile no.`,
                disabled: loading,
                onDataChange: (val) => {
                  setDisplayMessage(null);
                  if (!val) {
                    setFieldValue('whatsappNo', '');
                  } else {
                    setFieldValue('whatsappNo', values?.mobile);
                  }
                },
              }}
            />
            {!values?.isWhatsAppSameAsMobile && (
              <QuantaInput
                name="whatsappNo"
                size="full"
                type="number"
                step="1"
                min={1000000000}
                max={9999999999}
                onKeyDown={(evt) =>
                  evt.key === 'e' && evt.preventDefault()
                }
                label={
                  <Text type={'label'}>
                    {' '}
                    WhatsApp No <Text severity="error">*</Text>
                  </Text>
                }
                placeholder="Please enter your WhatsApp Number"
                onDataChange={(val, _) => {
                  setDisplayMessage(null);
                }}
                disabled={loading}
              />
            )}
            <QuantaInput
              name="alternateMobile"
              type={'text'}
              label={
                <Text type={'label'}>Alternative Mobile Nos</Text>
              }
              size={'full'}
              placeholder={'Enter alternative numbers for SMS'}
              disabled={loading}
              onDataChange={(val, _) => {
                setDisplayMessage(null);
              }}
              onKeyDown={(evt) => {
                if (
                  ['tab', 'enter', ',', ';']?.includes(
                    evt?.key?.toString()?.trim()?.toLowerCase(),
                  )
                ) {
                  evt.preventDefault();
                  if (
                    values?.alternateMobile &&
                    !validate(values)?.alternateMobile
                  ) {
                    setFieldValue(`alternateMobileNos`, [
                      ...values?.alternateMobileNos,
                      values?.alternateMobile?.trim(),
                    ]);
                    setFieldValue(`alternateMobile`, '');
                  }
                }
              }}
              onPaste={(evt) => {
                evt.preventDefault();
                const paste = evt?.clipboardData
                  .getData('text')
                  ?.toString()
                  ?.trim();
                const phones = paste?.match(/[0-9]{10}/g);
                if (phones) {
                  const toBeAdded = phones?.filter(
                    (phone) =>
                      !values?.alternateMobileNos?.includes(phone) &&
                      phone !== values?.mobile,
                  );
                  setFieldValue(`alternateMobileNos`, [
                    ...values?.alternateMobileNos,
                    ...toBeAdded,
                  ]);
                }
              }}
            />
            {values?.alternateMobileNos?.length > 0 && (
              <Text className="flex gap-3 flex-wrap">
                {values?.alternateMobileNos?.map(
                  (alternateMobile, idx) => {
                    return (
                      <Chip
                        key={idx}
                        onRemove={(_) =>
                          setFieldValue(`alternateMobileNos`, [
                            ...values?.alternateMobileNos?.slice(
                              0,
                              idx,
                            ),
                            ...values?.alternateMobileNos?.slice(
                              idx + 1,
                            ),
                          ])
                        }
                        isChipDisabled={loading}
                      >
                        {alternateMobile}
                      </Chip>
                    );
                  },
                )}
              </Text>
            )}
          </>
        ) : null}

        {displayMessage && !loading ? (
          <Text severity={sentSuccess ? 'success' : 'error'}>
            {displayMessage}
          </Text>
        ) : (
          <div>&nbsp;</div>
        )}

        <div className="flex flex-col space-y-3">
          <Button
            size="small"
            flat
            type={'button'}
            className="w-full"
            onClick={() => goBack()}
          >
            Back
          </Button>
          <Button
            size="small"
            className="w-full"
            type={'submit'}
            disabled={
              loading ||
              (!values?.mode?.sms && !values?.mode?.whatsapp)
            }
            iconPre={
              loading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin={true}
                  className="ml-2"
                />
              ) : (values?.mode?.sms && values?.mode?.whatsapp) ||
                (values?.mode?.sms && !values?.mode?.whatsapp) ||
                (!values?.mode?.sms && !values?.mode?.whatsapp) ? (
                <FontAwesomeIcon icon={faSms} className="ml-2" />
              ) : (
                <FontAwesomeIcon icon={faWhatsapp} className="ml-2" />
              )
            }
          >
            {loading
              ? `Sending...`
              : values?.mode?.sms && values?.mode?.whatsapp
              ? `Send SMS & WhatsApp`
              : values?.mode?.sms
              ? `Send SMS`
              : values?.mode?.whatsapp
              ? `Send WhatsApp`
              : `Send SMS`}
          </Button>
        </div>
      </QuantaForm>
    );
  };

  return (
    <>
      {loadingMobileNumberStartingWith && <Loading />}
      {errorMobileNumberStartingWith && (
        <Error error={errorMobileNumberStartingWith} />
      )}
      {mobileNumberStartingWith &&
        !loadingMobileNumberStartingWith &&
        !errorMobileNumberStartingWith && (
          <QuantaFormik {...{ initialValues, validate, onSubmit }}>
            <SendSMSForm {...{ initialValues, validate, onSubmit }} />
          </QuantaFormik>
        )}
    </>
  );
}
